module.exports = __webpack_public_path__ + "img/protection_skincover_natural.28e1941c.jpg";